export const syncMenu = {
	title: "Cardápio de Delivery ({{externalStoreType}})",
	description:
		"Selecione na lista da Zig o produto a ser associado com o item do {{externalStoreType}}. Os itens se tornarão únicos",
	menuNameExternalType: "Cardápio de Delivery ({{externalStoreType}})",
	entriesLabel: "Entradas",
	emptyTab: "Nenhum produto nesta aba.",
	emptyState: {
		title: "Não há produtos com pendências",
		description:
			"Os produtos sincronizados não apresentaram nenhuma pendência para ser corrigida",
	},
	tabs: {
		synced: "Sincronizados",
		pending: "Pendentes",
		notSynced: "Não sincronizados",
	},
	syncStatusTag: {
		synced: "Sincronizado",
		pending: "Pendente",
		notSynced: "Não sincronizado",
	},
	stepLabel: "Etapa {{number}}",
	requiredSuffix: "(obrigatório)",
	correctionSuggested: "{{count}} correção(ões) sugerida(s)",
	corrected: "CORRIGIDO",
	improvementSuggested: "{{count}} melhoria(s) sugerida(s)",
	improvementModal: {
		title: "Melhoria sugerida",
		types: {
			name: "Atualizar nome",
			price: "Atualizar preço",
			sku: "Atualizar SKU",
		},
		changeFromTo: 'De "{{current}}" para "{{suggested}}"',
		emptyValue: "(vazio)",
		cancel: "Cancelar",
		updateAll: "Atualizar tudo",
	},
	improvementSuccess: {
		title: "Sucesso!",
		description: "As sugestões foram corrigidas com sucesso!",
	},
	transferProducts: {
		warning:
			"{{amount}} produtos não foram sincronizados. Gostaria de importá-los para o cardápio de Delivery?",
		description: "Selecione os itens que gostaria de importar, ou finalize para seguir.",
		amountItemsSelected: "<strong>{{amount}}</strong> itens selecionados",
		completeBtn: "Concluir sem importar",
		importItemsBtn: "Importar itens",
	},
	notSynced: {
		pendingItems: "{{count}} itens pendentes",
		pendingDescription:
			"Não foi encontrado SKU similar entre produtos e complementos a serem sincronizados. Importe os itens listados para gerenciá-los na Zig.",
		itemsSelected: "{{selected}}/{{total}} itens selecionados",
		importInfo:
			"Os produtos serão importados de {{perPage}} em {{perPage}} para garantir o bom processamento do sistema",
		importButton: "Importar itens selecionados",
		requiredSuffix: "(Obrigatório)",
		empty: {
			title: "Nenhum produto para sincronizar",
			description:
				"Todos os produtos já foram importados e sincronizados na Zig.",
		},
	},
	bindProduct: {
		searchPlaceholder: "Busque outro produto para sincronizar",
		allProducts: "Todos os produtos",
		notProductFound: "Nenhum produto encontrado",
		errorProductFound: "Ocorreu um erro ao buscar os produtos",
		similarity: {
			title: "Nenhum produto similar encontrado",
			description:
				"Faça uma pesquisa na barra de busca acima, ou passe para o próximo produto.<br/>Você poderá importar os produtos sem similaridade ao final da sincronização.",
		},
		saveLater: "Salvar e continuar mais tarde",
		undo: "Desfazer ação anterior",
		completeSync: "Concluir sincronização",
		skipAll: "Ir para o último",
		skuInfo: {
			title: "O SKU desse produto será substituído",
			description:
				"O SKU da ZIG (produto selecionado ao lado) irá se sobrepor em ambos os cardápios. É isso que vai permitir uma gestão centralizada.",
		},
		undoModal: {
			title: "Desfazer sincronização",
			description:
				"Selecione quais produtos deseja desfazer a sincronização. Você pode sincronizá-los novamente a qualquer momento.",
			okText: "Desfazer sincronização",
			cancelText: "Cancelar",
		},
		reImport: "Reimportar produto",
		reImportLoading: "Reimportando produto...",
		reImportBlockedDuplicatedSku:
			"Não é possível reimportar: o produto possui complementos com SKU duplicado.",
		duplicatedSkuAlert: {
			title: "Reimportação indisponível",
			description:
				"Este produto possui SKUs duplicados entre ele e seus complementos. Ajuste os SKUs no iFood antes de realizar a reimportação.",
		},
	},
	productCard: {
		descriptionLabel: "Descrição",
		optionsLabel: "Opcionais",
		syncedSectionsLabel: "Seções sincronizadas",
		syncAriaLabel: "Sincronizar",
		active: "Ativo",
		inactive: "Inativo",
	},
	transferProductSuccess: {
		title: "Integração concluída",
		description:
			"Sua integração foi concluída e seus produtos foram sincronizados com sucesso!",
		button: "Ver produtos e cardápios",
	},
	syncMenuSuccess: {
		title: "Integração concluída",
		description:
			"Sua integração foi concluída e seus produtos foram sincronizados com sucesso!",
		button: "Ver produtos e cardápios",
		continue: "Ver produtos não importados",
	},
	errorContent: {
		title: "Não foi possível importar os produtos",
		description:
			"Algo inesperado aconteceu e não conseguimos concluir a importação dos produtos. Conclua sua integração e finalize seu cardápio mais tarde.",
		completeBtn: "Concluir sincronização sem importar",
		retryBtn: "Tentar importar novamente",
	},
	onboarding: {
		step1: {
			title: "Iremos exibir um produto de cada vez",
			description:
				"Cada produto importado será exibido ao lado de sugestões equivalentes no catálogo de produtos da ZIG. Você irá selecionar o produto ideal para unificar.",
		},
		step2: {
			title: "Um único SKU",
			description:
				"Ao selecionar o produto, o SKU da ZIG prevalecerá e você poderá fazer uma gestão centralizada no nosso dashboard.",
		},
		step3: {
			title: "Importe o que não estiver ainda na Zig",
			description:
				"Quando terminar de sincronizar os itens equivalentes, você poderá importar os produtos que não foram identificados no catálogo da ZIG. Assim, você terá todos os seus produtos em um só lugar!",
		},
		skipBtn: "Pular",
		submitBtn: "Começar sincronização",
	},
	completeSyncModal: {
		title: "Concluir sincronização",
		text:
			"Eba! Você sincronizou todos os produtos!<br/>Deseja desfazer a última sincronização ou podemos concluir essa etapa?",
		undoBtn: "Desfazer a última sincronização",
		completeBtn: "Concluir etapa",
	},
};
